import { render, staticRenderFns } from "./FormFiche.vue?vue&type=template&id=96cebdd4&"
import script from "./FormFiche.vue?vue&type=script&lang=js&"
export * from "./FormFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports